import { FC } from "react";
import { Button } from "../../../../components/buttons/button";
import styles from './KizButtonPanel.module.scss'
import { useTranslation } from "react-i18next";
import FlexRow from "../../../../components/controls/FlexRow";
import Tooltip from "../../../../components/tooltips/Tooltip";
import { CountdownStatusKizIcon, RequestStatusKizIcon, Send511512 } from "../../../../libs/corporate/icons/outlined/quickAccessBar/QuickAccessBarCollection";

interface IKizButtonPanel {
    kizStatus?: number | null;
    selectedItem?: IGridRow;
    onRequestStatusKiz: () => void;
    onReportStatusKiz: () => void;
    onSend511_512: () => void;
}

export const KizButtonPanel: FC<IKizButtonPanel> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value);

    return (
        <FlexRow className={styles.flexRow}>
           
                <Button
                    className={styles.kizButton}
                    variant={"kizPanel"}
                    onClick={props.onRequestStatusKiz}
                    disabled={(
                        props?.selectedItem?.cells?.find((c) => c.propertyName === "documentState")?.value === "Closed" ? false : true)
                        || (props.kizStatus === 4) ? true : false
                        || (props.kizStatus === 5) ? true : false
                    }
                >   <RequestStatusKizIcon className={styles.kizIcon}/>
                    {baseT('requestStatusKiz')}
                </Button>

                <Button
                    className={styles.kizButton}
                    variant={"kizPanel"}
                    onClick={props.onReportStatusKiz}
                    disabled={
                        props.kizStatus === 4
                        || props.kizStatus === null
                        || props.kizStatus === 5
                    }
                >
                    <CountdownStatusKizIcon className={styles.kizIcon}/>
                    {baseT('countdownStatusKiz')}
                </Button>

                <Button
                    className={styles.kizButton}
                    variant={"kizPanel"}
                    onClick={props.onSend511_512}
                    disabled={
                        props.kizStatus === 4
                        || props.kizStatus === null
                        || props.kizStatus === 5
                    }
                >
                    <Send511512 className={styles.kizIcon}/>
                    {baseT('send511/512')}
                </Button>
        </FlexRow>
    );
};
 